import api, { TableColluns, TipoGrafico } from "../api";

const controller = "crfAreaExecutiveSummary";

export interface CrfAreaExecutiveSummaryResult {
    descricaoDiretoria: string;
    variacao: number;
    forecastAno: number;
    orcadoAno: number;
    naoPrevisto: number;
    totalProjeto: number;
    mesAno: string;
    siglaDiretoria: string;
    siglaArea: string;
    siglaDepartamento: string;
    graficoTipoPacote: CrfGraficoTipoPacote;
    tipoProjetoForecast: CrfAreaExecutiveSummaryTipoProjetoForecastResult;
    resumoCapEx: CrfGraficoAreaExecutiveSummaryResumoCapExResult;
    graficoCurva: CrfAreaExecutiveSummaryCurvaEconomicaResult
}

export interface CrfGraficoTipoPacote {
    graficoBarra: TipoGrafico;
    dataSourceResult: Array<CrfAreaExecutiveSummaryTipoPacoteResult>;
    collunas: Array<TableColluns>;
}

export interface CrfAreaExecutiveSummaryTipoPacoteResult {
    totalMateria: number;
    totalServico: number;
    totalEsquipamento: number;

}

export interface CrfAreaExecutiveSummaryTipoProjetoForecastResult {
    series: Array<CrfSeriesData>;
}

export interface CrfSeriesData {
    name: string,
    y: number,
}


export interface CrfGraficoAreaExecutiveSummaryResumoCapExResult {
    capEx: number;
    contHidden: number;
    execu: number;
    execuHidden: number;
    reqs: number;
    reqsHidden: number;
    toCont: number;
    toContHidden: number;
    forecast: number;
    balance: number;
    sadoCapex: number;
}


export interface CrfAreaExecutiveSummaryCurvaEconomicaResult {
    collunsTable: Array<TableColluns>,
    tableDataSource: Array<any>,
    categorias: Array<string>,
    series: Array<any>,
}

export interface CrfFiltroPesquisaAreaExecutiveSummaryFromProps {
    diretoriaId?: string;
    areaId?: string;
    departamentoId?: string;
    fechamentoId?: string;
    telaInicial: boolean;
}


export const getCrfAreaExecutiveSummaryByUserId = (filtro: CrfFiltroPesquisaAreaExecutiveSummaryFromProps) =>
    api.get<CrfAreaExecutiveSummaryResult>(`${controller}/getAreaExecutiveSummaryByUserId`, { ...filtro });
export const getCrfAreaExecutiveSummary = (filtro: CrfFiltroPesquisaAreaExecutiveSummaryFromProps) => {
    return api.get<CrfAreaExecutiveSummaryResult>(`${controller}/getAreaExecutiveSummary`, { ...filtro });
};

